import { VALIDATION_MESSAGES } from '../constants/formConstants.js'

export const validateMinimumLength = (value) => (value.trim().length >= 2 ? null : VALIDATION_MESSAGES.MIN_LENGTH_ERROR)

export const validateField = (field, value) => {
  switch (field) {
    case 'apellido':
    case 'nombre':
      return validateMinimumLength(value)
    default:
      return null
  }
}
